/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
import{i as o,r as l,x as c}from"./lit-element-3JpVCGI4.js";import{t as m}from"./custom-element-BhZVzxrc.js";import{b as f,a as h}from"./events-QgU4WnF7.js";import{b as d}from"./styles-Cj2ukjKN.js";import{g}from"./collectionsRefinement-CetYF2b2.js";import"./config-Dus_iaC-.js";import"./compactObject-BJn0Ax-z.js";import"./isEqual-DXNOntVp.js";import"./escape-highlight-BQiRaWtq.js";import"./find-DUpcU4oq.js";import"./documentation-BCD0-z0w.js";import"./ph-Cp4vR8Iu.js";import"./algoliaAttributes-9-kn9y4O.js";import"./makes-COVixV7T.js";import"./models-CFyZBlbg.js";import"./years-BaEBeycS.js";var v=Object.defineProperty,w=Object.getOwnPropertyDescriptor,x=(a,t,r,i)=>{for(var e=i>1?void 0:i?w(t,r):t,n=a.length-1,p;n>=0;n--)(p=a[n])&&(e=(i?p(t,r,e):p(e))||e);return i&&e&&v(t,r,e),e};let s=class extends l{constructor(){super(...arguments),this._showAddVehicleView=()=>{g().length===0?this.dispatchEvent(f):this.dispatchEvent(h)}}render(){return c`<div class="wrapper">
      <h2>
        <kanter-icon icon="vehicle" filled></kanter-icon>
        <span class="uppercase">Select a vehicle & find the parts that fit</span>
      </h2>

      <button class="button__primary" @click="${this._showAddVehicleView}">
        <span>Select a vehicle</span><b>Select</b>
      </button>
    </div>`}};s.styles=[d,o`
      :host {
        width: 100%;
      }

      .wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: calc(2 * var(--space-unit));
        text-align: center;

        @media (min-width: 600px) {
          gap: calc(4 * var(--space-unit));
          flex-direction: row;
          text-align: left;
        }
      }

      kanter-icon {
        color: #000;
      }

      h2 {
        display: flex;
        align-items: center;
        letter-spacing: 0.1em;
        margin-block: 0;
        font-size: calc(var(--body-font-size) * 0.1rem);
        font-family: var(--navigation-font-family);
        font-style: var(--navigation-font-style);
        font-weight: var(--navigation-font-weight);
      }

      h2 span {
        padding-left: 15px;
        @media (max-width: 768px) {
          font-size: 11px;
          text-align: left;
        }
      }

      .button__primary {
        b {
          display: none;
        }
        @media (max-width: 600px) {
          padding: 8px 10px;

          span {
            display: none;
          }
          b {
            display: block;
          }
        }
      }

      .uppercase {
        text-transform: uppercase;
      }
    `];s=x([m("kanter-garage-empty")],s);
